/* gene-at.js: plays each homepage video only while it is on screen, and wires its pause button.
   People who ask for reduced motion get the poster and a Play button instead of autoplay. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const videos = document.querySelectorAll('video.js-at-video');
  if (!videos.length) return;

  const start = (v) => {
    if (v.dataset.userPaused || reduce) return;
    v.preload = 'auto';
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  };

  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => (e.isIntersecting ? start(e.target) : e.target.pause()));
      }, { threshold: 0.3 })
    : null;

  videos.forEach((v) => {
    if (reduce) v.pause();
    if (io) io.observe(v); else start(v);

    const btn = v.parentElement.querySelector('.js-at-toggle');
    if (!btn) return;
    const sync = () => {
      btn.textContent = v.paused ? 'Play' : 'Pause';
      btn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
    };
    v.addEventListener('play', sync);
    v.addEventListener('pause', sync);
    btn.addEventListener('click', () => {
      if (v.paused) {
        delete v.dataset.userPaused;
        v.preload = 'auto';
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      } else {
        v.dataset.userPaused = '1';
        v.pause();
      }
    });
    sync();
  });
})();
